class ApiError {
  constructor(message, code, response) {
    this.message = message;
    this.response = response;
    this.code = code;
  }
  get reason() {
    return this.response;
  }
  get statusCode() {
    return this.code;
  }
  get extra() {
    var _a;
    return (_a = this.response) == null ? void 0 : _a.extra;
  }
  get error() {
    var _a;
    return (_a = this.response) == null ? void 0 : _a.error;
  }
}

export { ApiError };
